// Hàm lấy base URL từ config hoặc mặc định
const getBaseUrl = () => {
  return window.APP_CONFIG?.API_BASE_URL || "http://localhost:7217";
};

const BASE = getBaseUrl();
const API_BASE = `${BASE}/api`;

const API_ENDPOINTS = {
  employees: `${API_BASE}/employees`,
  users: `${API_BASE}/user`,
  auth: `${API_BASE}/auth`,
  departments: `${API_BASE}/departments`,
  positions: `${API_BASE}/positions`,
  url: `${BASE}`,
  
  // Chat & SignalR Hubs
  chatUsers: `${API_BASE}/chat/users`,
  chatHub: `${BASE}/chatHub`, 
  broadcastHub: `${BASE}/broadcastHub`,

  // Chat Permissions
  getAllUsers: `${API_BASE}/UserChatPermissions/all-users`,
  getUserPermissions: (userId) => `${API_BASE}/${userId}`,
  setUserPermissions: (userId) => `${API_BASE}/${userId}`,

  // Broadcast
  getDepartments: `${API_BASE}/broadcast/departments`,
  sendBroadcast: `${API_BASE}/broadcast/send`,
  getBroadcastLogs: `${API_BASE}/broadcast/logs`,
  getBroadcastNotifications: `${API_BASE}/broadcast/notifications`,

  // 🔥 Quản lý Task
  taskjds: `${API_BASE}/taskjds`,
  taskjdassignments: `${API_BASE}/taskjdassignments`,
  taskdailies: `${API_BASE}/taskdailies`, 
 taskdailiesEveryDay: `${API_BASE}/taskdailies/everyday`,
  projects: `${API_BASE}/projects`,

  // ✨ Hệ thống Chấm công & Nghỉ phép
  attendance: `${API_BASE}/Attendance`, 
  branches: "/Branches", 
  
  // 🔔 QUẢN LÝ NGHỈ PHÉP (LEAVE REQUESTS)
  leaveRequests: `${API_BASE}/LeaveRequests`,
  getLeaveRequestById: (id) => `${API_BASE}/LeaveRequests/${id}`,
  approveLeaveRequest: (id) => `${API_BASE}/LeaveRequests/Approve/${id}`,
  // Thêm API Admin Management mà bạn vừa cung cấp
  adminManagementList: `${API_BASE}/LeaveRequests/admin-management-list`,
  
  // ✅ BỔ SUNG: Endpoint lấy bảng tổng hợp số dư phép năm
  annualLeaveRecords: `${API_BASE}/LeaveRequests/annual-leave-records`,

  // ✅ THÊM 2 DÒNG NÀY ĐỂ FIX LỖI Ở LAYOUT.JS
  leaveNotifications: (userId) => `${API_BASE}/LeaveRequests/notifications/${userId}`,
  markLeaveAsRead: (id) => `${API_BASE}/LeaveRequests/MarkAsRead/${id}`,

  // 📈 QUẢN LÝ KPI (Dựa trên Swagger & Excel)
  kpis: `${API_BASE}/KPIs`, 
  kpisActive: `${API_BASE}/KPIs/active`, // ✨ API lấy KPI trong kỳ hạn (Mới thêm)
  kpiDepartments: `${API_BASE}/KPIs/departments`,
  kpiUsers: `${API_BASE}/KPIs/users`,
  kpiExport: `${API_BASE}/KPIs/export`,
  kpiImport: `${API_BASE}/KPIs/import`,
  
  // ✅ Thêm Divisions (Khối)
  divisions: `${API_BASE}/divisions`,
  getDivisionById: (id) => `${API_BASE}/divisions/${id}`,
  deleteAllDivisions: `${API_BASE}/divisions/delete-all`,

  // 🤝 QUẢN LÝ ỦY QUYỀN (DELEGATIONS) - BỔ SUNG MỚI
  delegations: `${API_BASE}/Delegations`,
  delegationUsersLookup: `${API_BASE}/Delegations/users-lookup`,
  delegationDocumentTypes: `${API_BASE}/Delegations/document-types`,

  otApprovalConfigs: `${API_BASE}/OTApprovalConfigs`,
  getOtConfigById: (id) => `${API_BASE}/OTApprovalConfigs/${id}`,
  getOtConfigsByGroup: (groupName) => `${API_BASE}/OTApprovalConfigs/Group/${groupName}`,
  //DK tăng ca
  otRequests: `${API_BASE}/OTRequests`,
  getOtRequestById: (id) => `${API_BASE}/OTRequests/${id}`,
  approveOtRequest: (id) => `${API_BASE}/OTRequests/${id}/approve`,
  rejectOtRequest: (id) => `${API_BASE}/OTRequests/${id}/reject`,
  otNotifications: (userId) => `${API_BASE}/OTRequests/Notifications/${userId}`,
  markOtAsRead: (id) => `${API_BASE}/OTRequests/MarkAsRead/${id}`,
  getOtStats: (userId) => `${API_BASE}/OTRequests/Stats/TotalHours/${userId}`,


  // 📜 QUẢN LÝ VĂN BẢN QUY ĐỊNH & QUYẾT ĐỊNH (REGULATIONS - GỘP CHUNG)
  regulations: `${API_BASE}/Regulation`,
  getRegulationsByType: (type) => `${API_BASE}/Regulation?type=${type}`, // type: 'Decision' hoặc 'Rule'
  getRegulationById: (id) => `${API_BASE}/Regulation/${id}`,
  // 🔥 BỔ SUNG: Endpoint lấy cấu trúc dữ liệu dạng cây 3 tầng cho Sidebar/Hover Component
  getRegulationTree: `${API_BASE}/Regulation/Tree`,
  // ✉️ API KÍCH HOẠT GỬI EMAIL THÔNG BÁO CHO NHÂN VIÊN QUA ID VĂN BẢN
  sendRegulationNotificationEmail: (id) => `${API_BASE}/Regulation/SendNotification/${id}`,
  // ✅ BỔ SUNG: API xác nhận đã đọc văn bản quy định
  markRegulationAsRead: (id) => `${API_BASE}/Regulation/${id}/mark-as-read`,
  // 🔥 BỔ SUNG MỚI: 2 API Phân loại General và Personal theo Backend
  general: `${API_BASE}/Regulation/General`,
  personal: `${API_BASE}/Regulation/Personal`,

  // =================================================================
  // 💳 QUẢN LÝ YÊU CẦU THANH TOÁN (PAYMENT REQUESTS) - MỚI BỔ SUNG
  // =================================================================
paymentRequests: `${API_BASE}/PaymentRequests`,
getPaymentRequestById: (id) => `${API_BASE}/PaymentRequests/${id}`,
updatePaymentRequest: (id) => `${API_BASE}/PaymentRequests/${id}`,
deletePaymentRequest: (id) => `${API_BASE}/PaymentRequests/${id}`,
approvePaymentRequest: (id) => `${API_BASE}/PaymentRequests/${id}/approve`,
rejectPaymentRequest: (id) => `${API_BASE}/PaymentRequests/${id}/reject`,
paymentNotifications: (userId, params = {}) => {
  const query = new URLSearchParams();

  // Tự động append tất cả các tham số có giá trị hợp lệ
  Object.keys(params).forEach((key) => {
    if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
      query.append(key, params[key]);
    }
  });

  const queryString = query.toString();
  return `${API_BASE}/PaymentRequests/Notifications/${userId}${queryString ? `?${queryString}` : ""}`;
},
markPaymentAsRead: (id) => `${API_BASE}/PaymentRequests/MarkAsRead/${id}`,

  paymentApprovalConfigs: `${API_BASE}/PaymentRequestApprovalConfigs`,
  getPaymentConfigById: (id) => `{$API_BASE}/PaymentRequestApprovalConfigs/${id}`,

  getPaymentConfigsByGroup: (groupName) => `${API_BASE}/PaymentRequestApprovalConfigs/Group/${groupName}`,
  checkAttachmentRequirement: (step) => `${API_BASE}/PaymentRequestApprovalConfigs/CheckAttachmentRequirement?step=${step}`,

  // 🆕 Thêm đoạn này vào:
  filterOtRequests: (params) => {
    const { fromDate, toDate, status, createdBy } = params;
    const query = new URLSearchParams();
    if (fromDate) query.append('fromDate', fromDate);
    if (toDate) query.append('toDate', toDate);
    if (status !== undefined && status !== null && status !== "") query.append('status', status);
    if (createdBy) query.append('createdBy', createdBy);
    return `${API_BASE}/OTRequests/filter?${query.toString()}`;
  },

  // Hàm này đã kiểm tra kỹ: đảm bảo trả về string URL
getPaymentAdminList: (params) => {
  const query = new URLSearchParams();

  // Map giá trị chuỗi sang số tương ứng với Enum PartnerType của C#
  const targetMap = {
    "Nhà cung cấp": 0,
    "Khách hàng": 1,
    "Nội bộ": 2
  };

  // 1. Lọc theo Date
  if (params.fromDate) query.append('fromDate', params.fromDate);
  if (params.toDate) query.append('toDate', params.toDate);

  // 2. Lọc theo các ID/Trạng thái (Check để không append giá trị rỗng/undefined)
  if (params.status !== undefined && params.status !== "") query.append('status', params.status);
  if (params.departmentId) query.append('departmentId', params.departmentId);
  if (params.projectId) query.append('projectId', params.projectId);
  if (params.currentStep !== undefined && params.currentStep !== "") query.append('currentStep', params.currentStep);
  
  // 3. Lọc theo chuỗi
  if (params.businessUnit) query.append('businessUnit', params.businessUnit);
  if (params.costType) query.append('costType', params.costType);
  if (params.title) query.append('title', params.title);
  
  // 4. Lọc theo SupplierId (Mới thêm)
  if (params.supplierId) query.append('supplierId', params.supplierId);

  // 5. Lọc theo InternalDocumentType (Mới thêm)
  if (params.internalDocumentType) query.append('internalDocumentType', params.internalDocumentType);

  // 5. Xử lý PaymentTarget (Chuyển chuỗi sang số)
  if (params.paymentTarget !== undefined && params.paymentTarget !== "") {
    // Nếu giá trị nằm trong map thì lấy số, nếu không thì lấy chính nó (phòng trường hợp đã là số)
    const targetValue = targetMap[params.paymentTarget] ?? params.paymentTarget;
    query.append('paymentTarget', targetValue);
  }

  return `${API_BASE}/PaymentRequests/AdminList?${query.toString()}`;
},

  // 🏢 QUẢN LÝ NHÀ CUNG CẤP (SUPPLIER)
  suppliers: `${API_BASE}/SupplierApi`,
  getSupplierById: (id) => `${API_BASE}/SupplierApi/${id}`,
  importSuppliers: `${API_BASE}/SupplierApi/import`,
  exportSuppliers: `${API_BASE}/SupplierApi/export`,
getSuppliersByType: (type) => `${API_BASE}/SupplierApi/type/${type}`,
getNextPaymentCode: `${API_BASE}/PaymentRequests/next-code`,
// 🆕 API EXPORT EXCEL PAYMENT REQUESTS (Đã bổ sung ở đây)
 exportPaymentExcel: (ids, fromDate, toDate) => {
  const query = new URLSearchParams();

  // Thêm danh sách ids nếu có
  if (ids && ids.length > 0) {
    ids.forEach(id => query.append('ids', id));
  }

  // Thêm điều kiện ngày tháng nếu có
  if (fromDate) query.append('fromDate', fromDate);
  if (toDate) query.append('toDate', toDate);

  const queryString = query.toString();
  return `${API_BASE}/PaymentRequests/export-excel${queryString ? `?${queryString}` : ''}`;
},

menus: `${API_BASE}/Menus`,
  getMenuById: (id) => `${API_BASE}/Menus/${id}`,
  // API lấy menu theo User để hiển thị Sidebar
  getMenusByUser: (userId) => `${API_BASE}/Menus/user/${userId}`,
  // API lấy chi tiết quyền của User (để check checkbox trong trang admin)
  getUserPermissions: (userId) => `${API_BASE}/Menus/permissions/${userId}`,
  // API lưu phân quyền
  saveUserPermissions: `${API_BASE}/Menus/permissions`,

  // 🛡️ PHÂN QUYỀN MENU (PERMISSION MANAGEMENT)
  permissions: `${API_BASE}/Permission`,
  // Lưu phân quyền
  savePermissions: `${API_BASE}/Permission/save`,
  // Lấy danh sách menu đã được cấp quyền của một User hoặc Department
  getPermissions: (type, targetId) => `${API_BASE}/Permission/get-permissions/${type}/${targetId}`,
// 🆕 API mới để lấy menu của chính người đang đăng nhập
  myMenus: `${API_BASE}/Permission/my-menus`,

  leaveApprovalConfigs: `${API_BASE}/LeaveRequestApprovalConfigs`,
  getLeaveConfigById: (id) => `${API_BASE}/LeaveRequestApprovalConfigs/${id}`,
};

export default API_ENDPOINTS;